<script>
    export let infoText="Information";
</script>
<div class="no-results_info">
    <div class="row">
        <div class="col-2 col-md-1 text-center">
            <div class="pt-4 pb-4 pl-4">
                <span class="material-icons bigger blue">error_outline</span>
            </div>
        </div>
        <div class="col-10 col-md-11">
            <div class="pt-4 pb-4 pl-4">
                <strong style="font-size: 1.2em;">{infoText}</strong><br />
                <slot></slot>
            </div>
        </div>
    </div>
</div>
